import { ThemeProvider } from '@mui/material';
import './App.css';
import { Header, Landing, Home, MapViewer, Login } from './components';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { theme } from './bp-theme';
import { GlobalActionComponent, NotFoundPage } from './components/common';
import { GlobalActionProvider } from './store';

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <GlobalActionProvider>
            <Header />
            <Routes>
              <Route path='/' element={<Navigate to='/landing' replace />} />
              <Route path='/landing' element={<Landing />} />
              <Route path='/login' element={<Login />} />
              <Route path='/v1' element={<Home />} />
              <Route path='/v2' element={<MapViewer />} />
              <Route path='*' element={<NotFoundPage />} />
            </Routes>
            <GlobalActionComponent />
          </GlobalActionProvider>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}

export default App;
